import Axios from '../lib/axios'

class SuggestionService {
    
  async create (suggestion) {
    const result = await Axios.authenticated().post(
      `/suggestions`,
      suggestion
    )
    return result
  }

}

export default new SuggestionService()